const translations = {
  "en": {
    "360 Report": "360° Report"
  },
  "zh-tw": {
    "360 Report": "360° 報告"
  }
};

export default translations;
